import modalTemplateNameConflictUrl from './modal-template-name-conflict.html';
import ReplaceScheduleTemplateCtrl from './ReplaceScheduleTemplateCtrl';

export default class ScheduleTemplateCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    Utils,
    AlertService,
    $uibModalInstance,
    $uibModal,
    extendShiftModel,
    focus,
    sdk,
    /* resolves */ mode,
    dateFrom,
    dateTo,
    shifts
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      Utils,
      AlertService,
      $uibModalInstance,
      $uibModal,
      extendShiftModel,
      focus,
      sdk,
      /* resolves */ mode,
      dateFrom,
      dateTo,
      shifts,
    });

    this.shifts = this.shifts.map(extendShiftModel);
    this.hoursCount = this.Utils.sum(this.shifts.map((s) => s.duration));
    const locationNames = this.Utils.uniq(this.shifts.map((s) => s.location.name).sort());
    if (locationNames.length <= 3) {
      this.locationsDescription = this.Utils.addJoin(locationNames);
    } else {
      this.locationsDescription = `${locationNames.slice(0, 2).join(', ')} and ${
        locationNames.length - 2
      } more...`;
    }

    focus('name');
  }

  async save() {
    this.form?.$setSubmitted();
    if (this.form?.$invalid) {
      throw 'invalid form';
    }

    if (!this.shifts.length) {
      throw 'empty schedule';
    }

    const payload = {
      name: this.templateName,
      description: this.templateDescription,
      ignoreAssignees: this.ignoreAssignees,
      type: this.mode,
      shiftIds: this.shifts
        .filter(
          (s) => !this.ignorePlanning || s.status === this.sdk('constants').EVENT_STATUS.PUBLISHED
        )
        .map((s) => s.id),
    };

    try {
      await this.Authentication.sendRequest({
        method: 'post',
        path: 'shifts/templates',
        payload,
      });

      this.AlertService.success('Template has been successfully saved');
      this.$uibModalInstance.close();
    } catch (e) {
      if (e.status === 409 && e?.data.templateId) {
        this.replaceTemplate(e.data.templateId, payload);
      }

      throw e;
    }
  }

  async replaceTemplate(templateId, payload) {
    await this.$uibModal.open({
      templateUrl: modalTemplateNameConflictUrl,
      controller: ReplaceScheduleTemplateCtrl,
      controllerAs: 'ctrl',
      size: '620',
      resolve: {
        templateId: () => templateId,
        payload: () => payload,
      },
    }).result;

    this.AlertService.success('Template has been successfully replaced');
    this.$uibModalInstance.close();
  }
}
